import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id F74484E2-76FB-4671-9960-AE18E95F04FA
 * name star-four-points-outline
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-four-points-outline.svg
 * tags
 * - Shape 
 */
export const StarFourPointsOutlineIcon = createSvgIcon(<><path d="M12,6.7L13.45,10.55L17.3,12L13.45,13.45L12,17.3L10.55,13.45L6.7,12L10.55,10.55L12,6.7M12,1L9,9L1,12L9,15L12,23L15,15L23,12L15,9L12,1Z" /></>, 'StarFourPointsOutlineIcon');
export default StarFourPointsOutlineIcon